import { render } from "./CuponesHome.vue?vue&type=template&id=edce07ac&scoped=true"
import script from "./CuponesHome.vue?vue&type=script&lang=js"
export * from "./CuponesHome.vue?vue&type=script&lang=js"

import "./CuponesHome.vue?vue&type=style&index=0&id=edce07ac&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edce07ac"]])

export default __exports__